export default __webpack_public_path__ + "static/media/showcase-bg.6fc6d8e6.jpg";